import * as React from 'react';
import { InputAdornment, Typography } from '@mui/material';
import {
  RadioButtonGroupInput,
  required,
  TextInput,
  useTranslate,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import authProvider from '../../../../utils/authProvider';
import { ScheduleTasksInput } from './ScheduleTasksInput';
import { GlobalProcessTemplateIcon } from './ProcessTemplateName';
import { ProcessTemplateScope } from './types';

const scopeChoices: { id: ProcessTemplateScope; name: string }[] = [
  { id: 'customer', name: 'resources.process-templates.text.scope_customer' },
  { id: 'global', name: 'resources.process-templates.text.scope_global' },
];

export const ProcessTemplateForm = ({ disableScope = false, disabled = false }: {
  disableScope?: boolean;
  disabled?: boolean;
}) => {

  const translate = useTranslate();
  const scope = useWatch({ name: 'scope' });
  const canUseGlobalScope = authProvider.getRoles().includes('developer_admin');
  // On edit the scope is read-only, so keep both choices to show the current one.
  const choices = disableScope || canUseGlobalScope
    ? scopeChoices
    : scopeChoices.filter((choice) => choice.id !== 'global');

  return (
    <>
      <Typography variant="h6">{translate('resources.assets.text.general')}</Typography>
      <RadioButtonGroupInput
        source="scope"
        choices={choices}
        defaultValue="customer"
        disabled={disableScope || disabled}
      />
      <TextInput
        source="processName"
        validate={required()}
        disabled={disabled}
        InputProps={scope === 'global' ? {
          startAdornment: (
            <InputAdornment position="start">
              <GlobalProcessTemplateIcon />
            </InputAdornment>
          ),
        } : undefined}
      />
      <TextInput source="description" validate={required()} multiline disabled={disabled} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {translate('resources.process-templates.text.schedule_tasks')}
      </Typography>
      <ScheduleTasksInput source="scheduleTasks" disabled={disabled} />
    </>
  );

};
